<template>
  <Toast/>
  <div class="py-4 container-fluid">
    <div class="mt-4 row">
      <div class="col-12">
        <div class="card">
          <!-- Card header -->
          <div class="card-header border-bottom">
            <div class="row d-flex align-items-center">
              <div class="col-6">
                <h5 class="mb-0">Ingatlan Módosítása</h5>
              </div>
              <div class="col-6 text-end d-flex justify-content-end gap-4">
                <material-button 
                  class="float-right btn btm-sm"
                  @click="this.$router.push({ name: 'RealEstates List' })"
                  @click.prevent="handleEdit"
                  :loading="loading"
                >
                  Mentés
                </material-button>
                <material-button 
                  class="float-right btn btm-sm"
                  @click="this.$router.push({ name: 'RealEstates List' })"
                  color="secondary"
                >
                  Vissza
                </material-button>
              </div>
            </div>
          </div>
          <!--Card body-->
          <div class="card-body">
            <form>
              <div class="container my-6">
                <div class="row justify-content-center align-items-center">
                  <div class="col-12 d-flex flex-wrap justify-content-center align-items-center gap-6">
                    <div v-if="images.length > 0" class="d-flex flex-wrap justify-content-center gap-6">
                      <div v-for="image in images" :key="image.id" class="text-center">
                        <div @click="deleteMedia(image.id)" class="cursor-pointer" style="color: red;">✖</div>
                        <img :src="image.media_url" :alt="'Image ' + image.id" class="img-thumbnail cursor-pointer" style="width: 150px; height: 150px; object-fit: cover;" @click="openModal(image)"/>
                        <div class="bg-success text-white p-2 mt-1 rounded text-truncate" style="max-width: 150px; max-height: 150px; overflow: hidden; white-space: nowrap;">
                          {{ image.file_name }}
                        </div>
                      </div>
                    </div>
                    <div v-if="previewImages.length > 0" v-for="(image, index) in previewImages" :key="index" class="m-2 text-center" style="cursor: pointer;">
                      <div @click="removeImage(index)">✖</div>
                      <img :src="image" alt="Kép előnézete" class="img-thumbnail cursor-pointer" style="width: 150px; height: 150px; object-fit: cover;" @click="openModal(image)"/>
                      <div class="bg-success text-white p-2 mt-1 rounded text-truncate" style="max-width: 150px; overflow: hidden; white-space: nowrap;">
                        {{ fileNames[index] }}
                      </div>
                    </div>
                    <div v-if="totalImagesCount < 3" class="m-2 text-center d-flex flex-column align-items-center justify-content-center text-center" style="cursor: pointer; width: 150px; height: 120px;" @click="$refs.fileInput.click()">
                      <div class="d-flex align-items-center justify-content-center w-100 h-100">
                        <img src="@/assets/img/img-placeholder.webp" alt="Kép helyőrző" class="w-100 h-100" style="object-fit: cover;" />
                      </div>
                      <p class="text-white bg-success w-100 text-center fw-bold mb-0">Kép +</p>
                    </div>
                  </div>
                  <input type="file" ref="fileInput" multiple @change="handleFileUpload" accept="image/jpeg, image/png, image/webp" class="d-none" />
                </div>
              </div>
              <div v-if="modalVisible" class="modal fade show d-block" tabindex="-1" role="dialog" style="background: rgba(0,0,0,0.6); display: flex; align-items: center; justify-content: center; min-height: 100vh;">
                  <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title">{{ selectedImage?.file_name }}</h5>
                        <button type="button" class="btn-close cursor-pointer" @click="modalVisible = false"></button>
                      </div>
                      <div class="modal-body text-center">
                        <img :src="selectedImage?.media_url || selectedImage?.original_url" class="img-fluid" alt="Kép nagyban">
                      </div>
                      <div class="modal-footer">
                        <material-button type="button" color="secondary" @click="modalVisible = false">Bezárás</material-button >
                        <material-button class="btn btn-success" @click.prevent="downloadMedia(selectedImage?.id)">Letöltés</material-button >
                      </div>
                    </div>
                  </div>
              </div>
              <div class="d-flex flex-column flex-md-row gap-3 mb-4 mt-6">
                <div class="container text-center">
                  <div class="row border">
                      <div class="col-md-6 p-3 border-end fw-bold">Megnevezés</div>
                      <div class="col-md-6 p-2">
                        <material-input placeholder="Név" id="name" v-model:value="realestate.name"
                                        name="name" variant="static"></material-input>
                        <validation-error :errors="apiValidationErrors.name"></validation-error>
                      </div>
                  </div>
                  <div class="row border">
                      <div class="col-md-6 border-end fw-bold p-4">Ország</div>
                      <div class="col-md-6 pt-3">
                        <FormDropDown
                          v-if="realestate.country_code && getcountryList.length"
                          v-model.number="realestate.country_code"
                          :possible-values="getcountryList"
                          placeholder="Válassz országot!"
                          :searchable="true"
                          mode="single"
                        />
                      </div>
                  </div>
                  <div class="row border">
                      <div class="col-md-6 border-end p-3 fw-bold">Irányítószám</div>
                      <div class="col-md-6 p-2">
                        <material-input id="zip" v-model:value="realestate.zip" placeholder="Irányítószám"
                                        name="zip" variant="static" disabled></material-input>
                        <validation-error :errors="apiValidationErrors.zip"></validation-error>
                      </div>
                  </div>
                  <div class="row border">
                      <div class="col-md-6 border-end p-3 fw-bold">Város</div>
                      <div class="col-md-6 p-2">
                        <material-input id="city" v-model:value="realestate.city" placeholder="Város"
                                        name="city" variant="static" disabled></material-input>
                        <validation-error :errors="apiValidationErrors.city"></validation-error>
                      </div>
                  </div>
                  <div class="row border">
                      <div class="col-md-6 border-end p-3 fw-bold">Cím</div>
                      <div class="col-md-6 p-2">
                        <material-input id="address" v-model:value="realestate.address" placeholder="Cím"
                                        name="address" variant="static" disabled></material-input>
                        <validation-error :errors="apiValidationErrors.address"></validation-error>
                      </div>
                  </div>
                  <div class="row border">
                      <div class="col-md-6 border-end p-3 fw-bold">Helyrajzi Szám</div>
                      <div class="col-md-6 p-2">
                        <material-input placeholder="Helyrajzi Szám" id="lot_number"
                                        v-model:value="realestate.lot_number"
                                        name="lot_number" variant="static" disabled></material-input>
                        <validation-error :errors="apiValidationErrors.lot_number"></validation-error>
                      </div>
                  </div>
                  <div class="row border">
                      <div class="col-md-6 border-end p-3 fw-bold">Átépítés</div>
                      <div class="col-md-6 p-2">
                        <VueDatePicker 
                          v-model="realestate.reconstruction" 
                          :teleport="true" 
                          :enable-time-picker="false" 
                          select-text="Mentés" 
                          cancel-text="Mégse"
                        />
                        <validation-error :errors="apiValidationErrors.reconstruction"></validation-error>
                      </div>
                  </div>
                </div>

                <div class="container text-center">
                  <div class="row border">
                      <div class="col-md-6 border-end p-4 fw-bold">Tulajdonos</div>
                      <div class="col-md-6 pt-3">
                        <FormDropDown
                          v-if="realestate.owner_id && getownerList.length"
                          v-model.number="realestate.owner_id"
                          :possible-values="getownerList"
                          placeholder="Válassz tulajdonost!"
                          :searchable="true"
                          mode="single"
                        />
                      </div>
                  </div>
                  <div class="row border">
                      <div class="col-md-6 border-end p-3 fw-bold">Tulajdoni Hányad</div>
                      <div class="col-md-6 p-2">
                        <material-input id="ownership" v-model:value="realestate.ownership"
                                        placeholder="Tulajdoni hányad"
                                        name="ownership" variant="static"></material-input>
                        <validation-error :errors="apiValidationErrors.ownership"></validation-error>
                      </div>
                  </div>
                  <div class="row border">
                      <div class="col-md-6 border-end p-3 fw-bold">Tulajdoni Lap Szerinti Alapterület</div>
                      <div class="col-md-6 p-2">
                        <material-input id="deed_size" v-model:value="realestate.deed_size"
                                        placeholder="Tulajdoni lap szerinti alapterület (m2)"
                                        name="deed_size" variant="static"></material-input>
                        <validation-error :errors="apiValidationErrors.deed_size"></validation-error>
                      </div>
                  </div>
                  <div class="row border">
                      <div class="col-md-6 border-end p-4 fw-bold">Tulajdoni Lap Szerinti Megnevezés</div>
                      <div class="col-md-6 pt-3">
                        <FormDropDown
                          v-if="realestate.realestate_functions_id && getfunctionList.length"
                          v-model.number="realestate.realestate_functions_id"
                          :possible-values="getfunctionList"
                          placeholder="Válassz funkciót!"
                          :searchable="true"
                          mode="single"
                        />
                      </div>
                  </div>
                  <div class="row border">
                      <div class="col-md-6 border-end p-3 fw-bold">Kezelési Alapterület [Bruttó]</div>
                      <div class="col-md-6 p-2">
                        <material-input id="gross_size" v-model:value="realestate.gross_size"
                                        placeholder="Ingatlan bruttó alapterülete (m2)"
                                        name="gross_size" variant="static"></material-input>
                        <validation-error :errors="apiValidationErrors.gross_size"></validation-error>
                      </div>
                  </div>
                  <div class="row border">
                      <div class="col-md-6 border-end p-4 fw-bold">Ingatlankezelő</div>
                      <div class="col-md-6 pt-3">
                        <FormDropDown
                          v-if="getownerList.length"
                          v-model.number="realestate.realestate_property_manager_id"
                          :possible-values="getownerList"
                          placeholder="Válassz ingatlankezelőt!"
                          :searchable="true"
                          mode="single"
                        />
                      </div>
                  </div>
                </div>
              </div>
              <div class="container my-6">
                <div class="row justify-content-center align-items-center">
                  <div class="col-12 d-flex flex-wrap justify-content-center align-items-center gap-6 mt-4">
                    <div v-for="pdf in documents" :key="pdf.id" class="m-2 text-center" style="cursor: pointer;">
                      <div @click="deleteMedia(pdf.id)" class="cursor-pointer" style="color: red;">✖</div>
                      <div @click="showPdf(pdf)" class="rounded text-truncate border" style="max-width: 150px; overflow: hidden; white-space: nowrap;">
                        <img src="@/assets/img/pdf-placeholder.webp" alt="PDF" class="w-100 h-100" style="object-fit: cover;" />
                        <div class="border-t text-center bg-success text-white">
                          {{ pdf.file_name }}
                        </div>
                      </div>
                    </div>
                    <div v-for="(pdf, index) in pdfFiles" :key="index" class="m-2 text-center" style="cursor: pointer;">
                      <div class="" @click="removePdf(index)">✖</div>
                      <div class="rounded text-truncate border" style="max-width: 150px; overflow: hidden; white-space: nowrap;">
                        <img src="@/assets/img/pdf-placeholder.webp" alt="Kép helyőrző" class="w-100 h-100" style="object-fit: cover;" />
                        <div class="border-t text-center bg-success text-white">
                          {{ pdf.name }}
                        </div>
                      </div>
                    </div>
                    <div v-if="totalPdfCount < 3" class="mx-2 mt-4 text-center" style="cursor: pointer;" @click="openFilePicker">
                      <div class="rounded text-truncate border" style="max-width: 150px; overflow: hidden; white-space: nowrap;">
                        <img src="@/assets/img/pdf-placeholder.webp" alt="Kép helyőrző" class="w-100 h-100" style="object-fit: cover;" />
                        <div class="border-t text-center bg-success text-white">
                          PDF +
                        </div>
                      </div>
                    </div>
                  </div>
                  <input type="file" ref="pdfInput" multiple @change="handlePdfUpload" accept="application/pdf" class="d-none" />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormDropDown from "@/components/FormDropdown.vue";
import {ref, onMounted } from 'vue';
import {CButton, CCard, CCardBody, CCollapse} from '@coreui/vue-pro';
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import ValidationError from "@/components/ValidationError.vue";
import Modal from "@/components/Modal";
import formMixin from "@/mixins/formMixin.js";
import showSwal from "../../../mixins/showSwal";
import {FilterMatchMode} from '@primevue/core/api';
import { useRoute } from 'vue-router';
import MergeRealEstatesAreasModal from "./components/MergeRealEstatesAreasModal.vue";
import SeparateRealEstatesAreasModal from "./components/SeparateRealEstatesAreasModal.vue";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

export default {
  name: 'EditRealEstate',
  components: {
    MaterialButton,
    MaterialInput,
    ValidationError,
    CButton,
    CCollapse,
    CCard,
    CCardBody,
    Modal,
    FormDropDown,
    VueDatePicker,
    MergeRealEstatesAreasModal,
    SeparateRealEstatesAreasModal,
  },
  mixins: [formMixin],
  setup() {
    const visible = ref(true);
    const isModalForMergeOpen = ref(false);
    const isModalForSeparateOpen = ref(false);
    const selectedareas = ref(null);
    const realestateId = ref(null);
    const route = useRoute();

    onMounted(() => {
      realestateId.value = route.params.id;
    });

    const openModal = (selectedareas) => {
      if(selectedareas.length > 1) {
        isModalForMergeOpen.value = true;
      } else {
        isModalForSeparateOpen.value = true;
      }
    };

    const closeModal = () => {
        isModalForMergeOpen.value = false;
        isModalForSeparateOpen.value = false;
    };

    return {
      visible,
      color: '#33e8f5',
      isModalForMergeOpen,
      isModalForSeparateOpen,
      selectedareas,
      openModal,
      closeModal,
      realestateId,
    }
  },
  data() {
    return {
      data: [],
      realestate: {},
      areas: [],
      countries: {},
      owners: {},
      sfunctions: {},
      handlings: {},
      newArea: {},
      selected: null,
      areaDialog: false,
      deleteareaDialog: false,
      deleteareasDialog: false,
      area: {},
      selectedareas: null,
      filters: {},
      submitted: false,
      loading: false,
      selectedColumns: null,
      columns: null,
      previewImages: [],
      realEstateImages: [],
      pdfFiles: [],
      fileNames: [],
      images: [],
      documents: [],
      deleteMediaFiles: {},
      modalVisible: false,
      selectedImage: null,
    }
  },
  created() {
    this.initFilters();
    this.columns = [
      {field: 'identifier', header: 'Azonosító'},
      {field: 'area_buildings_id', header: 'Épület'},
      {field: 'area_numbers_id', header: 'Helység'},
      {field: 'area_functions_id', header: 'Funkció'},
      {field: 'area_positions_id', header: 'Pozíció'},
      {field: 'lot_number', header: 'Helyrajzi szám'},
      {field: 'net_floor_space', header: 'Nettó terület'},
      {field: 'gross_floor_space', header: 'Bruttó terület'},
      {field: 'height', header: 'Magasság'},
      {field: 'area_floor_coverings_id', header: 'Burkolat'},
    ];
    this.selectedColumns = this.columns;
  },
  computed: {
    getcountryList() {
      const data = this.$store.getters["countries/getCountriesData"] ?? [];
      return data.map(item => ({
                value: item.id,
                label: item.name
            }));
    },
    getownerList() {
      const data = this.$store.getters["contacts/getContactsBaseData"] ?? [];
      return data.map(item => ({
                value: item.id,
                label: item.name
            }));
    },
    getfunctionList() {
      const data = this.$store.getters["sfunctions/getFunctionsData"] ?? [];
      return data.map(item => ({
                value: item.id,
                label: item.name
            }));
    },
    getRentalUtilizationList() {
      return this.$store.getters["rentalutilization/getRentalUtilizationData"];
    },
    gethandlingList() {
      const data = this.$store.getters["handlings/getHandlingsData"] ?? [];
      return data.map(item => ({
                value: item.id,
                label: item.name
            }));
    },
    getAreaPositionsList() {
      return this.$store.getters["positions/getPositionsData"];
    },
    getAreaNumbersList() {
      return this.$store.getters["areanumbers/getAreanumbersData"];
    },
    getBuildingsList() {
      return this.$store.getters["buildings/getBuildingsData"];
    },
    areaPositionsList() {
      const data = this.getAreaPositionsList ?? [];
      return data.map(item => ({
                value: item.id,
                label: item.name
            }));
    },
    getAreaFunctionsList() {
      return this.$store.getters["afunctions/getFunctionsData"];
    },
    getAreaFloorCoveringsList() {
      return this.$store.getters["coverings/getCoveringsData"];
    },
    getRealestateList() {
      return this.$store.getters["realestates/getRealEstatesData"];
    },
    getMediaList() {
      const mediaList = this.$store.getters["media/getMediaData"];
      return mediaList || [];
    },
    getImage() {
      if (!this.profile_image)
        return require("@/assets/img/haz_rajz.jpg");
      else {
        return this.profile_image;
      }
    },
    computedBuildingId: {
      get() {
        if (this.area.area_buildings_id) {
          return this.area.area_buildings_id.toString()
        }
      },
      set(val) {
        this.area.area_buildings_id = Number(val)
      }
    },
    computedAreaNumbersId: {
      get() {
        if (this.area.area_numbers_id) {
          return this.area.area_numbers_id.toString()
        }
      },
      set(val) {
        this.area.area_numbers_id = Number(val)
      }
    },
    computedFunctionId: {
      get() {
        if (this.area.area_functions_id) {
          return this.area.area_functions_id.toString()
        }
      },
      set(val) {
        this.area.area_functions_id = Number(val)
      }
    },
    computedPositionId: {
      get() {
        if (this.area.area_positions_id) {
          return this.area.area_positions_id.toString()
        }
      },
      set(val) {
        this.area.area_positions_id = Number(val)
      }
    },
    computedFloorCoveringsId: {
      get() {
        if (this.area.area_floor_coverings_id) {
          return this.area.area_floor_coverings_id.toString()
        }
      },
      set(val) {
        this.area.area_floor_coverings_id = Number(val)
      }
    },
    totalPdfCount() {
      return this.pdfFiles.length + this.documents.length;
    },
    totalImagesCount() {
      return this.previewImages.length + this.images.length;
    },
    countCommonArea() {
      return this.areas.filter(area => area.identifier.includes("Közös terület")).length;
    },
    countOperations() {
      return this.areas.filter(area => area.identifier.includes("Üzemeltetés")).length;
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch("realestates/getRealEstate", this.$route.params.id);
      this.realestate = this.$store.getters["realestates/getRealEstate"][0];
      this.realestate.id = this.$route.params.id;

      let mediaPromises = [];
      if (this.realestate && this.realestate.media && this.realestate.media.length > 0) {
        mediaPromises = this.realestate.media.map(mediaItem =>
          this.$store.dispatch("media/getMedia", mediaItem.id)
            .then(() => {
              const mediaData = this.$store.getters["media/getMediaData"];
              if (mediaData) {
                if (mediaData.collection_name === "images") {
                  this.images.push(mediaData);
                } else if (mediaData.collection_name === "documents") {
                  this.documents.push(mediaData);
                }
              }
            })
            .catch(error => {
              console.error(`Error fetching the media (ID: ${mediaItem.id}):`, error);
            })
        );
      }

      const otherDataPromises = [
        this.$store.dispatch("buildings/getBuildings"),
        this.$store.dispatch("areanumbers/getAreanumbers"),
        this.$store.dispatch("countries/getCountries"),
        this.$store.dispatch("contacts/getContactsBaseData"),
        this.$store.dispatch("rentalutilization/getRentalUtilization"),
        this.$store.dispatch("sfunctions/getFunctions"),
        this.$store.dispatch("handlings/getHandlings"),
        this.$store.dispatch("positions/getPositions"),
        this.$store.dispatch("afunctions/getFunctions"),
        this.$store.dispatch("coverings/getCoverings"),
      ];

      await Promise.all([...mediaPromises, ...otherDataPromises]);

      if (this.realestate.areas.length > 0) {
        this.realestate.areas.forEach((owner) => {
          this.areas.push({
            id: owner.id,
            identifier: owner.identifier,
            area_buildings_id: owner.area_buildings_id,
            area_buildings: this.getBuildingsList.filter(val => val.id == owner.area_buildings_id),
            area_numbers_id: owner.area_numbers_id,
            area_numbers: this.getAreaNumbersList.filter(val => val.id == owner.area_numbers_id),
            lot_number: owner.lot_number,
            area_positions_id: owner.area_positions_id,
            area_position: this.getAreaPositionsList.filter(val => val.id == owner.area_positions_id),
            area_functions_id: owner.area_functions_id,
            area_function: this.getAreaFunctionsList.filter(val => val.id == owner.area_functions_id),
            net_floor_space: owner.net_floor_space,
            gross_floor_space: owner.gross_floor_space,
            height: owner.height,
            area_floor_coverings_id: owner.area_floor_coverings_id,
            area_floor_covering: this.getAreaFloorCoveringsList.filter(val => val.id == owner.area_floor_coverings_id),
          });
        });
      }

      this.loading = false;

    } catch (error) {
      console.error("Error loading data:", error);
      showSwal.methods.showSwal({
        type: "error",
        message: error,
        width: 500
      });
    }
  },
  methods: {
    showPdf(pdf) {
      const pdfUrl = pdf.media_url;
      window.open(pdfUrl, '_blank');
    },
    openFilePicker() {
      if (this.totalPdfCount < 3) {
        this.$refs.pdfInput.click();
      }
    },
    handleFileUpload(event) {
      if (!this.imageFiles) {
        this.imageFiles = [];
      }
      if (!this.realestate.files) {
        this.realestate.files = [];
      }

      const newFiles = Array.from(event.target.files);

      newFiles.forEach((file) => {
        if (file.type.startsWith("image/")) {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.previewImages.push(e.target.result); 
            this.imageFiles.push(file); 
            this.realestate.files.push(file); 
            this.fileNames.push(file.name);
          };
          reader.readAsDataURL(file);
        }
      });
    },
    removeImage(index) {
      this.previewImages.splice(index, 1);
      this.realestate.files.splice(index, 1);
      this.fileNames.splice(index, 1);
    },
    handlePdfUpload(event) {
      if (!this.realestate.files) this.realestate.files = [];
      const newPdfs = Array.from(event.target.files);

      newPdfs.forEach((file) => {
        if (file.type === "application/pdf") {
          this.pdfFiles.push(file);
          this.realestate.files.push(file);
        }
      });
    },
    removePdf(index) {
      const pdfName = this.pdfFiles[index].name;
      this.realestate.files = this.realestate.files.filter(file => file.name !== pdfName);
      this.pdfFiles.splice(index, 1);
    },
    openModal(image) {
      this.selectedImage = image;
      this.modalVisible = true;
    },
    async downloadMedia(mediaId) {
      await this.$store.dispatch("media/downloadMedia", mediaId);
    },  
    async refreshRealEstateData() {
      try {
        await this.$store.dispatch("realestates/getRealEstate", this.realestate.id);
        this.realestate = this.$store.getters['realestates/getRealEstate'][0];
      } catch (error) {
        console.log("Error in refreshing the realestate data:", error);
      }
    },
    addNewArea(newArea) {
      this.area.id = newArea.id;
      this.area.identifier = newArea.identifier;
      this.area.lot_number = newArea.lot_number;
      this.area.net_floor_space = newArea.net_floor_space;
      this.area.gross_floor_space = newArea.gross_floor_space;
      this.area.height = newArea.height;
      this.area.realestate_id = newArea.realestate_id;
      this.area.area_buildings = this.getBuildingsList.filter(val => val.id == newArea.area_buildings_id);
      this.area.area_numbers = this.getAreaNumbersList.filter(val => val.id == newArea.area_numbers_id);
      this.area.area_position = this.getAreaPositionsList.filter(val => val.id == newArea.area_positions_id);
      this.area.area_function = this.getAreaFunctionsList.filter(val => val.id == newArea.area_functions_id);
      this.area.area_floor_covering = this.getAreaFloorCoveringsList.filter(val => val.id == newArea.area_floor_coverings_id);
      this.areas.push(this.area);
      this.refreshRealEstateData();
    },
    addNewAreas(savedAreas) {
      savedAreas.forEach(newArea => {
        let area = {};
        area.id = newArea.id;
        area.identifier = newArea.identifier;
        area.lot_number = newArea.lot_number;
        area.net_floor_space = newArea.net_floor_space;
        area.gross_floor_space = newArea.gross_floor_space;
        area.height = newArea.height;
        area.realestate_id = newArea.realestate_id;
        area.area_buildings = this.getBuildingsList.filter(val => val.id == newArea.area_buildings_id);
        area.area_numbers = this.getAreaNumbersList.filter(val => val.id == newArea.area_numbers_id);
        area.area_position = this.getAreaPositionsList.filter(val => val.id == newArea.area_positions_id);
        area.area_function = this.getAreaFunctionsList.filter(val => val.id == newArea.area_functions_id);
        area.area_floor_covering = this.getAreaFloorCoveringsList.filter(val => val.id == newArea.area_floor_coverings_id);
        this.areas.push(area);
    });
      this.refreshRealEstateData();
    },
    editAreaNetGrossFloorSpace(editedArea) {
      const areaToEdit = this.areas.find(area => area.id === editedArea.id);
      if (areaToEdit) {
        areaToEdit.net_floor_space = editedArea.net_floor_space;
        areaToEdit.gross_floor_space = editedArea.gross_floor_space;
      }
    },
    deleteOldAreas(areaIds) {
      this.areas = this.areas.filter(area => !areaIds.includes(area.id));
    },
    formatCurrency(value) {
      if (value)
        return value.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
      return;
    },
    openNew() {
      this.area = {};
      this.submitted = false;
      this.areaDialog = true;
    },
    hideDialog() {
      this.areaDialog = false;
      this.submitted = false;
    },
    async savearea() {
      this.loading = true
      this.submitted = true;
        if (this.area.id) {
          this.area.id = this.area.id.toString();
          this.area.realestate_id = this.realestate.id;
          try {
            await this.$store.dispatch("areas/editArea", this.area);

            this.area.area_buildings = this.getBuildingsList.filter(val => val.id == this.area.area_buildings_id);
            this.area.area_numbers = this.getAreaNumbersList.filter(val => val.id == this.area.area_numbers_id);
            this.area.area_position = this.getAreaPositionsList.filter(val => val.id == this.area.area_positions_id);
            this.area.area_function = this.getAreaFunctionsList.filter(val => val.id == this.area.area_functions_id);
            this.area.area_floor_covering = this.getAreaFloorCoveringsList.filter(val => val.id == this.area.area_floor_coverings_id);

            this.areas[this.findIndexById(this.area.id)] = this.area;
            this.$toast.add({severity: 'success', summary: 'Sikeres', detail: 'Helység módosítva!', life: 3000});
            this.refreshRealEstateData();
          } catch (error) {
            this.$toast.add({severity: 'error', summary: 'HIBA', detail: error, life: 10000});
            this.areaDialog = false;
            this.area = {};
            this.loading = false
          }
        } else {
          this.area.realestate_id = this.realestate.id;
          try {
            const areaID = await this.$store.dispatch("areas/addArea", this.area);
            this.area.id = areaID.toString();

            this.area.area_buildings = this.getBuildingsList.filter(val => val.id == this.area.area_buildings_id);
            this.area.area_numbers = this.getAreaNumbersList.filter(val => val.id == this.area.area_numbers_id);
            this.area.area_position = this.getAreaPositionsList.filter(val => val.id == this.area.area_positions_id);
            this.area.area_function = this.getAreaFunctionsList.filter(val => val.id == this.area.area_functions_id);
            this.area.area_floor_covering = this.getAreaFloorCoveringsList.filter(val => val.id == this.area.area_floor_coverings_id);

            this.areas.push(this.area);
            this.$toast.add({severity: 'success', summary: 'Sikeres', detail: 'Helység hozzáadva!', life: 3000});
            this.refreshRealEstateData();
          } catch (error) {
            this.$toast.add({severity: 'error', summary: 'HIBA', detail: error, life: 10000});
            this.areaDialog = false;
            this.area = {};
            this.loading = false
          }
        }

        this.areaDialog = false;
        this.area = {};
      this.loading = false;
    },
    editarea(area) {
      this.area = {...area};
      this.areaDialog = true;
    },
    confirmDeletearea(area) {
      this.area = area;
      this.deleteareaDialog = true;
    },
    async deletearea() {
      this.areas = this.areas.filter(val => val.id !== this.area.id);
      this.deleteareaDialog = false;
      await this.$store.dispatch("areas/deleteArea", this.area.id);
      this.area = {};
      this.refreshRealEstateData();
      this.$toast.add({severity: 'success', summary: 'Successful', detail: 'area Deleted', life: 3000});
    },
    async deleteMedia(id) {
      try {
        await this.$store.dispatch('media/deleteMedia', id);
        this.images = this.images.filter(image => image.id !== id);
        this.documents = this.documents.filter(document => document.id !== id);
        showSwal.methods.showSwal({
          type: "success",
          message: "Sikeresen törölte a média tartalmat.",
          width: 500
        });

      } catch (error) {
        console.log("Hiba történt a média törlésekor:", error);
        showSwal.methods.showSwal({
          type: "error",
          message: "Hiba történt a média törlésekor.",
          width: 500
        });
      }
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.areas.length; i++) {
        if (this.areas[i].id == id) {
          index = i;
          break;
        }
      }

      return index;
    },
    exportCSV() {
      this.$refs.dt.exportCSV();
    },
    confirmDeleteSelected() {
      this.deleteareasDialog = true;
    },
    deleteSelectedareas() {
      this.areas = this.areas.filter(val => !this.selectedareas.includes(val));
      this.deleteareasDialog = false;
      this.selectedareas = null;
      this.$toast.add({severity: 'success', summary: 'Successful', detail: 'areas Deleted', life: 3000});
    },
    initFilters() {
      this.filters = {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      }
    },
    formatDate(date) {
  if (!date) return null;
  
  // Ha string-ként kapjuk a dátumot, konvertáljuk Date objektummá
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  
  // Ellenőrizzük, hogy érvényes dátum-e
  if (isNaN(dateObj.getTime())) return null;
  
  const year = dateObj.getFullYear();
  // Hónap és nap esetén 0-val kiegészítjük, ha egyjegyű
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
},

// A formázó függvény használata a kódban
// A method részbe illeszd be a formatDate függvényt, és itt módosítsd a handleEdit függvényt:
async handleEdit() {
  this.loading = true;
  this.resetApiValidation();
  try {
    this.realestate.deed_size = parseFloat(this.realestate.deed_size);
    this.realestate.gross_size = parseFloat(this.realestate.gross_size);
    
    // Dátum formázása a küldés előtt
    if (this.realestate.reconstruction) {
      this.realestate.reconstruction = this.formatDate(this.realestate.reconstruction);
    }
    
    this.realestate.areas = this.areas;
    await this.$store.dispatch("realestates/editRealEstate", this.realestate);
    showSwal.methods.showSwal({
      type: "success",
      message: "Ingatlan sikeresen módosítva!",
      width: 500
    });
    this.$router.push({name: "RealEstates List"})
  } catch (error) {
    if (error.response && error.response.data && error.response.data.errors) {
      this.setApiValidation(error.response.data.errors);
    }
    showSwal.methods.showSwal({
      type: "error",
      message: "Valami hiba történt!",
      width: 500
    });
  }
  this.loading = false;
},
    addArea(type, value) {
      if (type == 'commissioning_date') {
        this.newArea[type] = this.format(value);
      } else if (type == 'area_buildings_id' || type == 'area_numbers_id' || type == 'area_functions_id' || type == 'area_positions_id' || type == 'area_floor_coverings_id') {
        this.newArea[type] = Number(value);
      } else if (type == 'net_floor_space' || type == 'gross_floor_space' || type == 'height') {
        this.newArea[type] = parseFloat(value);
      } else {
        this.newArea[type] = value;
      }
    },
    onToggle(value) {
      this.selectedColumns = this.columns.filter(col => value.includes(col));
    }
  }
}
</script>